/* eslint-disable max-len */
import React from 'react';

function SecureBriefcaseIcon(props) {
  return (
    <svg width='17' height='18' viewBox='0 0 17 18' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <rect x='1.4248' y='6.25' width='14.15' height='10.75' rx='2' stroke='#677882' strokeWidth='2' />
      <path
        d='M4.6748 6.1C4.6748 4.4 4.6748 1 8.4998 1C12.3248 1 12.3248 4.4 12.3248 6.1'
        stroke='#677882'
        strokeWidth='2'
      />
      <path
        d='M10.2098 9.23133L7.4019 12.3448L6.63977 11.4997C6.36179 11.1915 5.91113 11.1915 5.63315 11.4997C5.35536 11.808 5.35536 12.3077 5.63315 12.6157L6.89869 14.0189C7.03768 14.173 7.21979 14.25 7.4019 14.25C7.58401 14.25 7.76613 14.173 7.90512 14.0189L11.2165 10.3473C11.4943 10.039 11.4943 9.53935 11.2165 9.23133C10.9385 8.92289 10.4878 8.92289 10.2098 9.23133Z'
        fill='#64737F'
      />
    </svg>
  );
}

export default SecureBriefcaseIcon;
